import React, {Component} from "react";
import { observer } from "mobx-react";
import NoticeListItemView from "views/main/body/layer/NoticeListItemView";
import {fn_noticeLeftNextPage, fn_noticeLeftPrevPage,} from "function/FnPage";

@observer
class NoticeListView extends Component {
    
    componentWillUnmount() {
        
    }

    render() {
        const { rootStore } = this.props;
        const settingStore = rootStore.settingStore;
        let sliceLeftList = settingStore.getNoticeList;
        
        //sliceLeftList = ( totalPage > 1 )?getNoticeList.slice((settingStore.getNoticePagingInfo.currentPage - 1) * 6, settingStore.getNoticePagingInfo.currentPage * 6):getNoticeList;

        return (
            <div className="section_notice">
                <h2>공지사항 목록</h2>
                <ul className="list_notice">
                    {(Array.isArray(sliceLeftList) && sliceLeftList.length > 0)
                    ?
                        sliceLeftList.map((obj, index)=>(
                        <NoticeListItemView key={index} rootStore={rootStore} obj={obj} />
                        )):null
                    }
                </ul>
                <div className="paging_notice">
                    <button type="button" className="prev"
                            disabled={settingStore.getNoticePagingInfo.currentPage === 1 ? "disabled" : ""}
                            onClick={(event)=>fn_noticeLeftPrevPage(rootStore)}
                    ><span>이전 페이지</span></button>
                    <p className="number">
                        <strong><span className="screen_out">현재 페이지</span>{settingStore.getNoticePagingInfo.currentPage} </strong>
                        /
                        <span className="screen_out">전체 페이지</span> {settingStore.getNoticePagingInfo.maxPage}
                    </p>
                    <button type="button" className="next"
                            disabled={settingStore.getNoticePagingInfo.currentPage === settingStore.getNoticePagingInfo.maxPage ? "disabled" : ""}
                            onClick={(event)=>fn_noticeLeftNextPage(rootStore)}
                    ><span>다음 페이지</span></button>
                </div>
            </div>
        );
    }
}

export default NoticeListView;